import { render } from "./ModalTemplate.vue?vue&type=template&id=4b9fc144&ts=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=ts"
export * from "./ModalTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dajetmiko/react/admin.animemo.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__